<template>
  <div>
		<h4>基本生理指标评估</h4>
		<table>
			<tr>
				<th>疾病史</th>
				<th>本次评估结果</th>
				<th>上次评估结果</th>
			</tr>
			<tr v-for="item in Object.keys(result.other.basic)" :key="item">
				<td>{{ result.other.basic[item].name }}</td>
				<td class="centerTd">
					<span style="color: #888;font-size: 16px;">{{ result.other.basic[item].value }}</span>
					<span v-if="result.other.basic[item].level" :class="[`t${getLevelClass(result.other.basic[item])}`]">{{getLevel(result.other.basic[item])}}</span>
				</td>
				<td></td>
			</tr>
		</table>
		<h4>既往疾病</h4>
		<table>
			<tr>
				<th>疾病史</th>
				<th>本次评估结果</th>
				<th>上次评估结果</th>
			</tr>
			<tr v-for="item in Object.keys(result.other.history)" :key="item">
				<td>{{ result.other.history[item].name }}</td>
				<td>
					<span :style="{color:result.other.history[item].value?'#E46860':' #888', fontSize: '16px'}">{{ getValue(result.other.history[item].value) }}</span>
					<span v-if="result.other.history[item].level">{{result.other.history[item].levelModel[result.other.history[item].level]}}</span>
				</td>
				<td></td>
			</tr>
		</table>

		<h4>健康危险因素</h4>
		<table>
			<tr>
				<th>危险因素</th>
				<th>本次评估结果</th>
				<th>上次评估结果</th>
			</tr>
			<tr v-for="item in Object.keys(result.other.risk)" :key="item">
				<td>{{ result.other.risk[item].name }}</td>
				<td><span v-if="result.other.risk[item].value">✓</span></td>
				<td></td>
			</tr>
		</table>		
  </div>

</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';

export default {  
	props: {
		result: Object
	},
	// watch: {
	// 	visible() {
	// 		if (this.visible) {
	// 			this.filter.type = this.type;
	// 			this.loadList();
	// 		}
	// 	}
	// },	
	data(){
		return {}
	},
	created() {},
	methods: {
		getLevelClass(item){
			if(item.key=='bmi'){
				switch(item.level){
					case 1:return 0;
					case 2: return 1;
					case 3: return 2;
					case 4: return 3;
				}
			} else {
				switch(item.level){
					case 1:return 0;
					case 2: return 1;
					case 3: return 5;
					case 4: return 2;
					case 5: return 3;
				}
			}
		},
		getLevel(data) {
			let value=Object.keys(data.levelModel).find(k=>{
				return data.levelModel[k]==data.level
			})
			return value;
			
		},
		getValue(val) {
			switch (val){
				case true: return '有'; 
				case false: return '无'; 
			}
			// if (!list || list.length === 0) {
			// 	return '无';
			// }
			// let value = list?.map(item => {
			// 	return this.result.other.historyValuesModel[item];
			// });
			// return value.join(',');
		}
	}
}
</script>

<style lang="less" scoped>
	.centerTd{
		text-align: center;
	}
	.step-2 table td{
		.t0,.t1,.t2,.t3,.t5{
			font-family: Source Han Sans CN;
			font-size: 10px;
			font-weight: normal;
			letter-spacing: 0em;
			padding: 0 10px;
			border-radius: 26.5px;
			text-align: center;
			display: inline-block;
			margin-top: 2px;
		}
		.t0{
			border: 1px solid #68BBF4;
			color: #68BBF4;
		}
		.t1{
			border: 1px solid #74AA60;
			color: #74AA60;
		}
		.t2{
			border: 1px solid #EF8C3A;
			color: #EF8C3A;
		}
		.t3{
			border: 1px solid #E46860;
			color: #E46860;
		}
		.t5{
			border: 1px solid #579840;
			color: #579840;
		}
	}
// @import './template.less';	
</style>
